import React from 'react'

const Intermediate = () => {
  return (
    <div>Intermediate</div>
  )
}

export default Intermediate